import {Switch} from '@mantine/core';
import classes from './switch.module.css';

export const SwitchTheme = Switch.extend({
  classNames: {
    thumb: classes.thumb,
    track: classes.track,
  },
});